import SearchResultUserList from './SearchResultUserList';

export default SearchResultUserList;
